import React from "react";
import { Row, Col, Button } from "antd";
import { ArrowBack } from "@material-ui/icons";

import LoginSignupStyled from "../styles/LoginSignup";
import useWindowResize from "../../hooks/useWindowResize";

const LoginSignupTemplate = ({ children }) => {
  
  const mobile = useWindowResize()

  return (
    <LoginSignupStyled>
      <Row>
        <Col span={!mobile ? 8 : 0} className="imageContainer">
          <img src="/images/monitor.png" className="bgImage" />
          <div className="contentWrapper">
            <ArrowBack className="icon" />
            <Button type="link" href="/" className="backButton">
              HomePage
            </Button>
            <div className="logoContainer">
              <img
                src={process.env.whiteLabel ? "/fg_logo.png" : "/logo.png"}
                alt="logo"
                width="250"
              />
            </div>
          </div>
        </Col>
        <Col span={!mobile ? 16 : 24}>{children}</Col>
      </Row>
    </LoginSignupStyled>
  );
};

export default LoginSignupTemplate;
